module.exports = __webpack_public_path__ + "media/D_sound_switch.0cc6c04a.mp3";